export default __webpack_public_path__ + "static/media/ios-icon.042f3eb9.svg";